var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{staticClass:"notise",attrs:{"group":"message","position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }